import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { NbAccessChecker } from '@nebular/security';

@Component({
  selector: 'dum-private-menu',
  templateUrl: './private-menu.component.html',
  styleUrls: ['./private-menu.component.scss']
})
export class PrivateMenuComponent implements OnInit {

  items: MenuItem[];
  constructor(
    private translateService: TranslateService,
    private accessChecker: NbAccessChecker) { }

  ngOnInit(): void {
    this.items = [
      {
        label: this.translateService.instant('MENU.PRIVADO.GESTION.USUARIOS'),
        icon: '',
        visible: this.isVisible('admin-users'),
        items: [
          {
            label: this.translateService.instant('MENU.PRIVADO.USUARIOS'),
            icon: 'pi pi-users',
            routerLink: ['lista-usuarios']
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.REGISTRAR.USUARIO'),
            icon: 'pi pi-user-plus',
            routerLink: ['registro-usuario']
          },
        ]
      },
      {
        label: this.translateService.instant('MENU.PRIVADO.GESTION.CONFIGURACION.PLAZAS'),
        icon: '',
        visible: this.isVisible('admin-plazas'),
        items: [
          {
            label: this.translateService.instant('MENU.PRIVADO.LISTA.PLAZAS'),
            icon: 'fas fa-car',
            routerLink: ['lista-plazas']
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.GENERAR.CODIGOS.QR'),
            icon: 'fas fa-qrcode',
            routerLink: ['generar-codigos-qr']
          },
        ]
      },
      {
        label: this.translateService.instant('MENU.PRIVADO.GESTION.VEHICULOS'),
        icon: '',
        visible: this.isVisible('admin-vehiculos'),
        items: [
          {
            label: this.translateService.instant('MENU.PRIVADO.VEHICULOS'),
            icon: 'fas fa-truck',
            routerLink: ['vehiculos'],
            visible: this.isVisible('admin-vehiculos')
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.SECTORES.PROFESIONALES'),
            icon: 'fas fa-chart-pie',
            routerLink: ['sectores']
          },
        ]
      },
      {
        label: this.translateService.instant('MENU.PRIVADO.GESTION.EDICION.PLAZAS.APARCAMIENTO'),
        icon: '',
        visible: this.isVisible('admin-regulacion') || this.isVisible('admin-sesionesEstacionamiento'),
        items: [
          {
            label: this.translateService.instant('MENU.PRIVADO.GESTION.PLAZAS.APARCAMIENTO.REGULADO'),
            icon: 'fas fa-parking',
            routerLink: ['lista-regulacion-plazas'],
            visible: this.isVisible('admin-regulacion')
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.CONSULTA.SESION.ESTACIONAMIENTO'),
            icon: 'pi pi-clock',
            routerLink: ['consulta-sesion-estacionamiento'],
            visible: this.isVisible('admin-sesionesEstacionamiento')
          }
        ]
      },
      {
        label: this.translateService.instant('MENU.PRIVADO.CONTROL.USO.PLAZAS.CARGA.DESCARGA'),
        icon: '',
        visible: this.isVisible('admin-alertas') || this.isVisible('admin-sesionesEstacionamiento') || this.isVisible('admin-zonaVigilancia'),
        items: [
          {
            label: this.translateService.instant('MENU.PRIVADO.CONTROL.USO.PLAZAS.CARGA.DESCARGA.ALERTAS'),
            icon: 'fas fa-exclamation-triangle',
            routerLink: ['alertas'],
            visible: this.isVisible('admin-alertas')
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.CONTROL.USO.PLAZAS.CARGA.DESCARGA.INFRACCION.ALERTAS'),
            icon: 'fas fa-eye',
            routerLink: ['infraccion-alertas'],
            visible: this.isVisible('admin-alertas')
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.CONTROL.USO.PLAZAS.CARGA.DESCARGA.ESTADISTICAS.ALERTAS'),
            icon: 'pi pi-chart-bar',
            routerLink: ['estadisticas-alertas'],
            visible: this.isVisible('admin-alertas')
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.CONTROL.USO.PLAZAS.CARGA.DESCARGA.GESTION.INCIDENCIAS.SESIONES'),
            icon: 'pi pi-exclamation-circle',
            routerLink: ['gestion-incidencias-sesiones'],
            visible: this.isVisible('admin-sesionesEstacionamiento')
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.CONTROL.USO.PLAZAS.CARGA.DESCARGA.ZONAS.VIGILANCIA'),
            icon: 'fas fa-street-view',
            routerLink: ['zonas-vigilancia'],
            visible: this.isVisible('admin-zonaVigilancia')
          }
        ]
      },
     /* {
        label: this.translateService.instant('MENU.PRIVADO.MONITORIZACION.GESTION.EVENTOS'),
        icon: '',
        visible: this.isVisible('admin-historicoSesiones'),
        items: [
          {
            label: this.translateService.instant('MENU.PRIVADO.ANALISIS.USO.PLAZAS'),
            icon: 'pi pi-chart-line',
            routerLink: ['analisis-uso-plazas']
          }
        ]
      },*/
      {
        label: this.translateService.instant('MENU.PRIVADO.CUADRO.DE.MANDOS'),
        icon: '',
        visible: this.isVisible('admin-sesionesEstacionamiento') || this.isVisible('admin-historicoSesiones'),
        items: [
          {
            label: this.translateService.instant('MENU.PRIVADO.PANEL.DE.CONTROL.TIEMPO.REAL'),
            icon: 'fas fa-business-time',
            routerLink: ['panel-control-tiempo-real'],
            visible: this.isVisible('admin-sesionesEstacionamiento')
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.VISUALIZACION.MAPA.ESTADO.DISPONIBILIDAD.PLAZAS'),
            icon: 'fas fa-globe-europe',
            routerLink: ['mapa-plazas-tiempo-real'],
            visible: this.isVisible('admin-sesionesEstacionamiento')
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.INFORMES'),
            icon: 'fas fa-file-download',
            routerLink: ['informes'],
            visible: this.isVisible('admin-historicoSesiones')
          }
        ]
      },
      {
        label: this.translateService.instant('MENU.PRIVADO.SOPORTES'),
        icon: '',
        visible: this.isVisible('admin-contactoSoporte'),
        items: [
          {
            label: this.translateService.instant('MENU.PRIVADO.SOPORTES.LISTA.TEMAS'),
            icon: 'fas fa-list-alt',
            routerLink: ['lista-temas']
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.SOPORTES.LISTA.SOPORTES'),
            icon: 'fas fa-ticket-alt',
            routerLink: ['lista-soportes']
          },
        ]
      },
      {
        label: this.translateService.instant('MENU.PRIVADO.GESTION.NOTICIAS'),
        icon: '',
        visible: this.isVisible('admin-noticias'),
        items: [
          {
            label: this.translateService.instant('MENU.PRIVADO.GESTION.NOTICIAS.LISTA'),
            icon: 'far fa-newspaper',
            routerLink: ['lista-noticias']
          },
          {
            label: this.translateService.instant('MENU.PRIVADO.GESTION.NOTICIAS.ANADIR'),
            icon: 'far fa-plus-square',
            routerLink: ['noticia/nuevo']
          },
        ]
      },
    ];
  }


  isVisible(opcion: string): boolean {
      let isGranted = false;
      this.accessChecker.isGranted('view', opcion ).subscribe((result) => {
        isGranted = result;
      });
      return isGranted;
  }

}
